<app-template>
  <app-menu-modulo menu [menu]="menu"></app-menu-modulo>
</app-template>